const projectsDatabase = {
  "PixieDust": {
    "category": "WEBSITES",
    "images": [
      {"source": "/images/pixiedust.png"},
      {"source": "/images/raytracer.png"},
      {"source": "/images/solar.png"}
    ],
    "embeded": "false",
    "title": "PixieDust",
    "description": "A website project focused on XYZ."
  },
  "3DWatchHistory": {
    "category": "WEBSITES",
    "images": [
      {"source": "/images/3dwatch.png"}
    ],
    "embeded": "false",
    "title": "3D Watch History",
    "description": "3D visualization of watch history using ABC framework."
  },
  "Roam": {
    "category": "WEBSITES",
    "images": [
      {"source": "/images/roam.png"}
    ],
    "embeded": "false",
    "title": "Roam",
    "description": "A project on building a virtual roaming environment."
  },
  "ConceptGenerator": {
    "category": "WEBSITES",
    "images": [
      {"source": "/images/conceptgenerator.png"}
    ],
    "embeded": "false",
    "title": "Concept Generator",
    "description": "Generates concepts based on user input."
  },
  "ConnectGT": {
    "category": "WEBSITES",
    "images": [
      {"source": "/images/connectatgt.png"}
    ],
    "embeded": "false",
    "title": "Connect @GT",
    "description": "A platform for connecting students at GT."
  },
  "ClutchIt": {
    "category": "WEBSITES",
    "images": [
      {"source": "/images/clutchit.png"}
    ],
    "embeded": "false",
    "title": "Clutch.It",
    "description": "An app for managing student organizations."
  },
  "30SecondAnimation": {
    "category": "COMPUTER GRAPHICS",
    "images": [
      {"source": "/images/animation.png"}
    ],
    "embeded": "false",
    "title": "30 Second Animation",
    "description": "An animation project showcasing various techniques in animation."
  },
  "RayTracing": {
    "category": "COMPUTER GRAPHICS",
    "images": [
      {"source": "/images/raytracer.png"}
    ],
    "embeded": "false",
    "title": "Ray Tracing Renderer",
    "description": "This project was done for my computer graphics course. I wrote a collection of javascript functions that creates a 3D scene and produces 2D images of the scene. I made 8 different scenes that render different variations of spheres and cylinders in different lighting/shading. I also implemented shadow creation and surface reflections."
  },
  "GPUProgramming": {
    "category": "COMPUTER GRAPHICS",
    "images": [
      {"source": "/images/gpu.png"}
    ],
    "embeded": "false",
    "title": "GPU Programming",
    "description": "Implementing GPU-based computation for rendering scenes."
  },
  "DualMeshes": {
    "category": "COMPUTER GRAPHICS",
    "images": [
      {"source": "/images/dualmeshes.png"}
    ],
    "embeded": "false",
    "title": "Dual Meshes",
    "description": "Dual mesh implementation for enhanced 3D rendering."
  },
  "Starfall": {
    "category": "GAME DEV",
    "images": [
      {"source": "/images/starfall.png"}
    ],
    "embeded": "false",
    "title": "Starfall",
    "description": "A 2D game where the player avoids falling stars."
  },
  "Labaretto": {
    "category": "GAME DEV",
    "images": [
      {"source": "/images/labaretto.png"}
    ],
    "embeded": "false",
    "title": "Labaretto",
    "description": "A puzzle game featuring a labyrinth."
  },
  "FollowTheRedRabbit": {
    "category": "GAME DEV",
    "images": [
      {"source": "/images/redrabbit.png"}
    ],
    "embeded": "false",
    "title": "Follow the Red Rabbit",
    "description": "A maze game where the player follows a rabbit."
  },
  "MbedFruitNinja": {
    "category": "GAME DEV",
    "images": [
      {"source": "/images/fruitninja.png"}
    ],
    "embeded": "false",
    "title": "Mbed Fruit Ninja",
    "description": "A Fruit Ninja style game made using the Mbed platform."
  },
  "KillBillPlatformerMaze": {
    "category": "GAME DEV",
    "images": [
      {"source": "/images/killbill.png"}
    ],
    "embeded": "false",
    "title": "Kill Bill Platformer Maze",
    "description": "A platformer maze game with Kill Bill theme."
  },
  "Runwei": {
    "category": "FIGMA",
    "images": [
      {"source": "/images/runwei.png"}
    ],
    "embeded": "false",
    "title": "Runwei",
    "description": "A Figma project focused on UI/UX design for a running app."
  },
  "PlantIdentifier": {
    "category": "FIGMA",
    "images": [
      {"source": "/images/plantidentifier.png"}
    ],
    "embeded": "false",
    "title": "Plant Identifier",
    "description": "A design project for identifying plants through image recognition."
  }
}

export default projectsDatabase;